export enum FieldTypeEnum {
  MODEL = 1,
  SUB_MODEL = 2,
  SUB_SUB_MODEL = 3,
  SUB_SUB_SUB_MODEL = 4,
  AMOUNT_FIELD = 5,
  DATE_FIELD = 6
}
